import { Injectable } from '@angular/core';
import {Template} from '../contracts/template.interface';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import { TableFilter } from '../../shared/contracts/table-column.interface';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {
  private API_URL = 'templates/';

  constructor(private http: HttpClient) {}

  getAll(page = 1, size = 10, filters: TableFilter[] = []): Observable<{ data: Template[]; total: number }> {
    let params = new HttpParams().set('page', page).set('size', size);
    for (const f of filters) {
      params = params.append('filter_field', f.field);
      params = params.append('filter_value', f.value);
      params = params.append('filter_match', f.matchMode);
    }
    return this.http.get<{ data: Template[]; total: number }>(this.API_URL, { params });
  }

  create(template: Template): Observable<Template> {
    return this.http.post<Template>(this.API_URL, template);
  }

  update(id: number, template: Template): Observable<Template> {
    return this.http.put<Template>(`${this.API_URL}${id}`, template);
  }

  delete(id: number): Observable<Template> {
    return this.http.delete<Template>(`${this.API_URL}${id}`);
  }
}
